module.exports = __webpack_public_path__ + "static/img/startbild.d36050c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/startbild.png
// module id = Q3+H
// module chunks = 1